/**
 * Handles redirects based on URL parameters and localStorage
 * 
 * @description This function checks for a 'then' parameter in the URL,
 * stores the redirect path in localStorage, and checks for an 'until'
 * condition that specifies a window variable to check. It redirects users
 * when the specified window variable is true and clears the stored path
 * if the current path matches it.
 */
const handleRedirect = () => {
  const getRedirectPath = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('then');
  };

  const getUntilCondition = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('until');
  };

  const storedRedirectPath = window.localStorage.getItem('redirectPath');
  const storedUntilCondition = window.localStorage.getItem('redirectUntil');
  
  const currentPath = window.location.pathname;
  const redirectPath = getRedirectPath();
  const untilCondition = getUntilCondition();

  if (redirectPath) {
    window.localStorage.setItem('redirectPath', redirectPath);
    
    if (untilCondition) {
      window.localStorage.setItem('redirectUntil', untilCondition);
    } else {
      window.localStorage.removeItem('redirectUntil');
    }
  }
  
  if (storedRedirectPath) {
    if (currentPath === storedRedirectPath) {
      window.localStorage.removeItem('redirectPath');
      window.localStorage.removeItem('redirectUntil');
    } 
    else {
      if (storedUntilCondition) {
        try {
          const conditionParts = storedUntilCondition.split('.');
          let conditionValue = window;
          
          for (const part of conditionParts) {
            if (conditionValue && conditionValue[part] !== undefined) {
              conditionValue = conditionValue[part];
            } else {
              conditionValue = undefined;
              break;
            }
          }
          
          if (conditionValue === true) {
            window.localStorage.removeItem('redirectUntil');
            window.location.href = storedRedirectPath;
          }
        } catch (error) {
          // Silent error handling to match codebase style
        }
      } 
      else {
        window.location.href = storedRedirectPath;
      }
    }
  }
};

/**
 * Check if the redirect condition is met and perform redirect if needed
 * 
 * @description This function can be called after state changes that might
 * affect the condition. It checks if there's a stored condition and runs
 * the redirect logic if one exists.
 */
const checkRedirectCondition = () => {
  const storedUntilCondition = window.localStorage.getItem('redirectUntil');
  
  if (storedUntilCondition) {
    handleRedirect();
  }
};

handleRedirect();

export { handleRedirect, checkRedirectCondition };
export default handleRedirect;